// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

export const linkStyle01 = css`
    &,
    * {
        color: ${getColor("text.main")} !important;

        &:hover,
        &:focus {
            text-decoration: underline !important;
            color: ${getColor("primary.main")} !important;
            outline: 0 !important;
        }
    }

    &[disabled] {
        &,
        *,
        &:hover,
        &:focus {
            opacity: 0.5;
            text-decoration: none !important;
            color: ${getColor("text.main")} !important;
        }
    }
`;

export const linkStyle02 = css`
    &,
    * {
        color: ${getColor("primary.main")} !important;

        &:hover,
        &:focus {
            text-decoration: underline !important;
        }
    }
`;

export const linkStyle02WithAnchor = css`
    a {
        ${linkStyle02};
    }
`;
